import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../features/auth/authSlice";
import paiementReducer from "../features/paiement-validation/paiementSlice";

export const store = configureStore({
    reducer: {
        auth: authReducer,
        paiement: paiementReducer
    }
});